// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"E1-z","colorTextValue":"F1-z","swatches":"G1-z","collapseLink":"H1-z","isCollapsed":"I1-z","dropdown":"J1-z","disabled":"K1-z"};